module.exports = __webpack_public_path__ + "static/media/questionnarie_icon.c1daff7e.png";